// extracted by mini-css-extract-plugin
export default {"appartBulle":"Appart_appartBulle__cElYU","appartImage":"Appart_appartImage__vlNcP","appartTexte":"Appart_appartTexte__8RA5l"};